// extracted by mini-css-extract-plugin
module.exports = {"group":"Group_group__3QAdN","active":"Group_active__2NqTh","head":"Group_head__3TtB4","menu":"Group_menu__EFk6K","link":"Group_link__W3Nmp"};